export const Y_CONNECTOR = 6;
export const Y_CONNECTOR_PADDING = 4;

export const HOVER_CIRCLE_RADIUS_ACTIVE = 4;
export const HOVER_CIRCLE_RADIUS = 2;
